import { useMatch } from 'react-router-dom';
import { AppRoutePath } from 'config/constants';

export const useViewerId = (): string | null | undefined => {
  const match = useMatch(AppRoutePath.VIEWER);

  return match?.params.windowId;
};
